module.exports = __webpack_public_path__ + "static/media/first.31ecc4df.jpeg";